// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';
import wixData from 'wix-data';
// import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

function projectsRep() {
	let language = wixWindow.multilingual.currentLanguage;
    $w('#projectsDB').onReady(() => {
        $w('#projectsRep').onItemReady(($w, itemData, index) => {
			if (language === 'bg') {
				$w('#title').text = itemData.title;
				$w('#desc').html = itemData.desctiption;
			} else {
				$w('#title').text = itemData.title_eng;
				$w('#desc').html = itemData.description_engl;
			}
        });
    });
}

$w.onReady(function () {
	projectsRep();
});